import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/content/$kind")({
  staticData: { sitemap: false },
  component: () => <Outlet />,
});
